var exports = {
  "k": "xe564cbfb--c7c6ec--container",
  "Q": "xe564cbfb--c7c6ec--content",
};

module.exports = exports;
